module.exports = __webpack_public_path__ + "static/media/gill-sans-for-jl-regular.0c1e8a33.woff";